import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
    const { t } = useLanguage();

    return (
        <footer className="bg-stone-900 text-stone-300 py-24" data-testid="footer">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-16 md:gap-12">
                    {/* Brand */}
                    <div className="md:col-span-2">
                        <h2 className="font-display text-2xl text-white mb-6">Raw Minerals</h2>
                        <p className="text-stone-400 leading-relaxed max-w-md">
                            {t('footerDescription')}
                        </p>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h3 className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-6">{t('navigate')}</h3>
                        <nav className="flex flex-col gap-4">
                            <Link to="/products" className="text-stone-300 hover:text-white transition-colors">
                                {t('collection')}
                            </Link>
                            <Link to="/about" className="text-stone-300 hover:text-white transition-colors">
                                {t('ourStory')}
                            </Link>
                            <Link to="/cart" className="text-stone-300 hover:text-white transition-colors">
                                {t('cart')}
                            </Link>
                            <Link to="/brochure" className="text-stone-300 hover:text-white transition-colors">
                                {t('brochure')}
                            </Link>
                        </nav>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-6">{t('contact')}</h3>
                        <div className="flex flex-col gap-4 text-stone-400">
                            <p>Oslo, Norway</p>
                            <a 
                                href="mailto:hello@rawminerals.no" 
                                className="text-stone-300 hover:text-white transition-colors inline-flex items-center gap-1"
                            >
                                hello@rawminerals.no
                                <ArrowUpRight className="w-4 h-4" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom */}
                <div className="mt-24 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-stone-500">
                        © {new Date().getFullYear()} Raw Minerals. {t('allRightsReserved')}
                    </p>
                    <p className="text-xs text-stone-500">
                        {t('norwaysFirstCurator')}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
